import React, { useEffect } from "react";
import ContactForm from "../components/ContactForm";
import Header from "../components/Header";

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="font-serif">
      <Header />
      <ContactForm />
    </div>
  );
}
